"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
	function r(e, n, t) {
		function o(i, f) {
			if (!n[i]) {
				if (!e[i]) {
					var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
				}var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
					var n = e[i][1][r];return o(n || r);
				}, p, p.exports, r, e, n, t);
			}return n[i].exports;
		}for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
			o(t[i]);
		}return o;
	}return r;
})()({ 1: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				wpAdminBar: $('#wpadminbar'),
				siteHeader: $('.site-header')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				var $dom = this.$dom;

				function moveIfAdminBar() {
					$dom.siteHeader.css('top', $dom.wpAdminBar.height());
					$dom.wpAdminBar.css('position', 'fixed');
				};

				function addGlobalContentOffset() {
					var admBarH = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

					$('.global-margin-top').css('margin-top', $dom.siteHeader[0].getBoundingClientRect().bottom + 'px');
					$('.global-padding-top').css('padding-top', $dom.siteHeader[0].getBoundingClientRect().bottom + 'px');
					$('.global-admin-margin').css('margin-top', admBarH + 'px');
				}

				if ($dom.wpAdminBar.length > 0) {
					moveIfAdminBar();
					addGlobalContentOffset($dom.wpAdminBar.height());
				} else {
					addGlobalContentOffset();
				}

				Global.$dom.window.on('resize', function () {
					clearTimeout(window.resizedFinished);
					window.resizedFinished = setTimeout(function () {
						if ($dom.wpAdminBar.length > 0) {
							moveIfAdminBar();
							addGlobalContentOffset($dom.wpAdminBar.height());
						} else {
							addGlobalContentOffset();
						}
					}, 250);
				});
			}
		};
	}, { "./global": 3 }], 2: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it

		$(document).ready(function () {
			$('.tab-a').click(function () {
				$(".tab").removeClass('tab-active');
				$(".tab[data-id='" + $(this).attr('data-id') + "']").addClass("tab-active");
				$(".tab-a").removeClass('active-a');
				$(this).parent().find(".tab-a").addClass('active-a');
			});
		});

		// Slide for tab
		var tabs = document.getElementsByClassName('Tab');

		Array.prototype.forEach.call(tabs, function (tab) {
			tab.addEventListener('click', setActiveClass);
		});

		function setActiveClass(evt) {
			Array.prototype.forEach.call(tabs, function (tab) {
				tab.classList.remove('active');
			});

			evt.currentTarget.classList.add('active');
		}

		// Toggler dropabbile like question and answer
		var action = "click";
		var speed = "500";

		$(document).ready(function () {
			// Question handler
			$('div.toggler').on(action, function () {
				// Get next element
				var self = $(this);
				if ($(this).hasClass('clicked')) {
					self.removeClass('clicked');
				} else {
					self.addClass('clicked');
				}
				$(this).next().slideToggle(speed)
				// Select all other answers
				.siblings('div.toggler-content').slideUp();
			});
		});
	}, { "./global": 3 }], 3: [function (require, module, exports) {
		"use strict";

		module.exports = {
			$dom: {
				window: $(window),
				body: $('body')
			},

			vars: {
				windowWidth: window.innerWidth
			},

			functions: {
				escKey: function escKey(callback) {
					$(document).on('keyup', function (e) {
						if (e.keyCode === 27) {
							callback();
						}
					});
				},

				clickOutsideContainer: function clickOutsideContainer(selector, container, closeBtn, callback) {
					selector.on('mouseup', function (e) {
						e.preventDefault();
						if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
							callback();
						}
					});
				}
			}
		};
	}, {}], 4: [function (require, module, exports) {
		"use strict";

		var Global = require('./global');
		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				menuBtn: $('.js-menu-btn'),
				menuNav: $('.js-main-nav'),
				menuHasSub: $('.menu-item-has-children')
			},

			classes: {
				open: 'open',
				openMenu: 'menu-open'
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;
				var classes = this.classes;

				// functions
				function closeNav() {
					$dom.menuBtn.removeClass(classes.open);
					$dom.menuNav.removeClass(classes.open);
					Global.$dom.body.removeClass(classes.openMenu);
				}

				if (Global.vars.windowWidth < 768) {
					$dom.menuHasSub.each(function (i, el) {
						$(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
					});
				}

				// bind events
				$dom.menuBtn.on('click', function (e) {
					e.preventDefault();
					$dom.menuBtn.toggleClass(classes.open);
					$dom.menuNav.toggleClass(classes.open);
					Global.$dom.body.toggleClass(classes.openMenu);
				});

				$dom.menuNav.on('click', '[data-open-sub]', function () {
					if (Global.vars.windowWidth < 768) {
						$(this).siblings('.sub-menu').slideToggle();
					}
				});

				Global.functions.clickOutsideContainer($dom.menuNav, $dom.menuNav.children('ul'), $dom.menuBtn, closeNav);

				Global.functions.escKey(closeNav);
			}
		};
	}, { "./global": 3 }], 5: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it
		/**********************************
   * Hide nav when scroll down
  **********************************/
		$(document).ready(function () {

			'use strict';

			var c,
			    currentScrollTop = 0,
			    navbar = $('header');

			$(window).scroll(function () {
				var a = $(window).scrollTop();
				var b = navbar.height();

				currentScrollTop = a;

				if (c < currentScrollTop && a > b + b) {
					navbar.addClass("scrollUp");
				} else if (c > currentScrollTop && !(a <= b)) {
					navbar.removeClass("scrollUp");
				}
				c = currentScrollTop;
			});
		});
	}, { "./global": 3 }], 6: [function (require, module, exports) {
		// Google passive listeners to improve scrolling performance
		(function () {
			var supportsPassive = eventListenerOptionsSupported();

			if (supportsPassive) {
				var addEvent = EventTarget.prototype.addEventListener;
				overwriteAddEvent(addEvent);
			}

			function overwriteAddEvent(superMethod) {
				var defaultOptions = {
					passive: true,
					capture: false
				};

				EventTarget.prototype.addEventListener = function (type, listener, options) {
					var usesListenerOptions = (typeof options === "undefined" ? "undefined" : _typeof(options)) === 'object';
					var useCapture = usesListenerOptions ? options.capture : options;

					options = usesListenerOptions ? options : {};
					options.passive = options.passive !== undefined ? options.passive : defaultOptions.passive;
					options.capture = useCapture !== undefined ? useCapture : defaultOptions.capture;

					superMethod.call(this, type, listener, options);
				};
			}

			function eventListenerOptionsSupported() {
				var supported = false;
				try {
					var opts = Object.defineProperty({}, 'passive', {
						get: function get() {
							supported = true;
						}
					});
					window.addEventListener("test", null, opts);
				} catch (e) {}

				return supported;
			}
		})();
	}, {}], 7: [function (require, module, exports) {
		"use strict";

		var Global = require('./global'); // require Global only if you need it

		$("ul.qa-row").find('li').click(function () {
			var self = $(this);
			$(this).find('> ul').slideToggle(300, function () {
				if ($(this).is(':visible')) {
					self.find('.icon').removeClass('fal fa-plus-square').addClass('fal fa-minus-square');
				} else {
					self.find('.icon').removeClass('fal fa-minus-square').addClass('fal fa-plus-square');
				}
			});
			self.siblings().next('> ul').slideUp(250);
		});
	}, { "./global": 3 }], 8: [function (require, module, exports) {
		/*********************************
  # Select filter button
  # Page Speakers
  # Page Palladiums
  # Page Q&A
  *********************************/
		$(document).ready(function () {
			$("select").change(function () {
				$(this).find("option:selected").each(function () {
					var optionValue = $(this).attr("value");
					if (optionValue) {
						$(".qaFilter").not("." + optionValue).hide();
						$("." + optionValue).show();
					} else {
						$(".qaFilter").hide();
					}
				});
			}).change();
		});
	}, {}], 9: [function (require, module, exports) {
		"use strict";

		module.exports = {
			/*-------------------------------------------------------------------------------
   	# Cache dom and strings
   -------------------------------------------------------------------------------*/
			$dom: {
				slider: $('.donators-list-slide')
			},

			/*-------------------------------------------------------------------------------
   	# Initialize
   -------------------------------------------------------------------------------*/
			init: function init() {
				// get dom and strings
				var $dom = this.$dom;

				// slider
				$dom.slider.slick({
					infinite: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					speed: 300,
					arrows: true,
					autoplay: true,
					dots: false,
					customPaging: function customPaging(slider, i) {
						var thumb = $(slider.$slides[i]).data();
						return '<a></a>';
					},
					responsive: [{
						breakpoint: 1024,
						settings: {
							slidesToShow: 3
						}
					}, {
						breakpoint: 991,
						settings: {
							slidesToShow: 2
						}
					}, {
						breakpoint: 767,
						settings: {
							slidesToShow: 1
						}
					}]
				});
			}
		};
	}, {}], 10: [function (require, module, exports) {
		jQuery(function ($) {
			// Site Menu
			var menu = require('./_site/menu');
			menu.init();

			// Slick Slider
			var sliders = require('./_site/sliders');
			sliders.init();

			// Admin Menu
			var adminHeader = require('./_site/adminHeader');
			adminHeader.init();

			// Navigation
			var navigation = require('./_site/navigation');

			// Google passive listener for scroll
			var passiveListener = require('./_site/passiveLiestener');

			// Q&A
			var qa = require('./_site/qa');

			// Filter Q&A
			var qaFilter = require('./_site/qaFilter');

			// Filter Q&A
			var domTab = require('./_site/domTab');
		});
	}, { "./_site/adminHeader": 1, "./_site/domTab": 2, "./_site/menu": 4, "./_site/navigation": 5, "./_site/passiveLiestener": 6, "./_site/qa": 7, "./_site/qaFilter": 8, "./_site/sliders": 9 }] }, {}, [10]);